import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';

import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

import {
  GeaMesCognitoModule,
  COGNITO_CONFIG,
  GeaMesAuthInterceptor,
  APPLICATION_NAME,
  ALLOW_SCREENAUTH,
  APIGATEWAY_CONFIG,
  GeaMesCognitoAuthService
} from '@gea-mes/cognito';

import {
  GEA_MES_NAVBAR_COGNITO_CONFIG,
  GEA_MES_NAVBAR_APPLICATION_NAME,
  GEA_MES_NAVBAR_COGNITO_AUTH_SERVICE,
  GEA_MES_NAVBAR_MENU_SERVICE,
  GEA_MES_NAVBAR_ENV_PROD_STATUS,
  GEA_ENVIROMENT,
  GEA_MES_NAVBAR_APP_ID_FOR_WHATSNEW_TEXT
} from '@gea-mes/navbar';

import { environment } from '../environments/environment';
import { appinfo } from './appinfo';
import { NavItem } from './nav-item.service';
import { EquipmentService } from './plant/equipment/equipment.service';
import { LineService } from './plant/lines/line.service';
import { PlantService } from './plant/plant.service';
import { SublineService } from './plant/lines/line-manger/sublines/subline.service';
import { DeltaService } from './plant/subAssemblyDelta/delta.service';
import { Globals } from './app.globals';
import { NavItemService } from './nav-item.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),

    importProvidersFrom(GeaMesCognitoModule),

    { provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: COGNITO_CONFIG, useValue: environment.cognitoOptions },
    { provide: HTTP_INTERCEPTORS, useClass: GeaMesAuthInterceptor, multi: true },
    { provide: APPLICATION_NAME, useValue: appinfo.name.toUpperCase() },
    { provide: APIGATEWAY_CONFIG, useValue: environment.apiGateway },
    { provide: ALLOW_SCREENAUTH, useValue: environment.AllowScreenAuth },

    { provide: GEA_MES_NAVBAR_COGNITO_AUTH_SERVICE, useClass: GeaMesCognitoAuthService },
    { provide: GEA_MES_NAVBAR_APPLICATION_NAME, useValue: 'Brilliant Config' },
    { provide: GEA_MES_NAVBAR_ENV_PROD_STATUS, useValue: environment.production },
    { provide: GEA_MES_NAVBAR_COGNITO_CONFIG, useValue: environment.cognitoOptions },
    { provide: GEA_MES_NAVBAR_MENU_SERVICE, useValue: new BehaviorSubject<NavItem[]>([]) },
    { provide: GEA_ENVIROMENT, useValue: environment },
    { provide: GEA_MES_NAVBAR_APP_ID_FOR_WHATSNEW_TEXT, useValue: 'BrilliantConfig' },

    EquipmentService,
    LineService,
    PlantService,
    SublineService,
    DeltaService,
    Globals,
    NavItemService
  ]
};